// =====================================================================================
// INVRT Radar — web console — account
//
// The shell for the account area: the heading and the tab registration. Every panel
// lives in its own file under ./account/ (C1 split). The active tab is URL-driven
// (`?tab=`), not local state, so a link elsewhere in the console (the "top up credits"
// links on QuoteApproveCard and ErrorState, both /account?tab=credits) lands on the right
// tab rather than always opening to Ledger — the same pattern SiteDetailPage uses.
//
// Tab ids, in display order: ledger, credits, usage, pricing, access, keys, team,
// delivery, rights. The "keys", "team" and "delivery" panels landed with the C1 wave
// (21 Aug 2026): API keys, team members and delivery (webhooks, email and CRM targets).
// The "access" panel landed with PS6: the organisation's subscribed modules and the
// not-subscribed catalogue with a request action (contract C6).

// Every money figure in these panels is one Postgres computed and the API handed over;
// the console formats, it never adds up. See each panel's own header.
// =====================================================================================

import { useSearchParams } from "react-router-dom";
import { Tabs } from "@/components/ui/tabs";
import { AccessUpgradesSection } from "@/components/upsell/UpsellPanel";
import { LedgerPanel } from "./account/LedgerPanel";
import { CreditsPanel } from "./account/CreditsPanel";
import { UsagePanel } from "./account/UsagePanel";
import { PricingPanel } from "./account/PricingPanel";
import { ApiKeysPanel } from "./account/ApiKeysPanel";
import { TeamPanel } from "./account/TeamPanel";
import { DeliveryPanel } from "./account/DeliveryPanel";
import { DataRightsPanel } from "./account/DataRightsPanel";

export function AccountPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") ?? "ledger";

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-xl font-semibold text-ink">Account</h1>
        <p className="mt-1 text-sm text-ink-muted">
          Your ledger, your credits, your usage, your prices, and your data rights.
        </p>
      </div>

      <Tabs
        activeId={tab}
        onChange={(next) => setSearchParams({ tab: next })}
        items={[
          { id: "ledger", label: "Ledger", content: <LedgerPanel /> },
          { id: "credits", label: "Credits", content: <CreditsPanel /> },
          { id: "usage", label: "Usage", content: <UsagePanel /> },
          { id: "pricing", label: "Prices", content: <PricingPanel /> },
          { id: "access", label: "Access", content: <AccessUpgradesSection /> },
          { id: "keys", label: "API keys", content: <ApiKeysPanel /> },
          { id: "team", label: "Team", content: <TeamPanel /> },
          { id: "delivery", label: "Delivery", content: <DeliveryPanel /> },
          { id: "rights", label: "Data rights", content: <DataRightsPanel /> },
        ]}
      />
    </div>
  );
}
